/**
 * Yeniden-kimlik-doğrulama köprüsü (019): 401'de tek noktalı, deduplike bir kanca tetiklenir
 * (FR-007/FR-008). Kancaya bağlanan gerçek davranış `AuthProvider`'dadır.
 */

// Eşzamanlı çoklu 401'i tek tetiğe indirgemek için zaman-pencereli dedup.
const DEDUP_WINDOW_MS = 3000
let handler: (() => void) | null = null
let lastTriggeredAt = 0

export function setUnauthorizedHandler(fn: (() => void) | null): void {
  handler = fn
}

/**
 * 401'de çağrılır. Deduplike: pencere içinde ikinci 401 yeni tetik üretmez (FR-008).
 * @returns Bu çağrı gerçekten tetikledi mi (`true`) yoksa deduplike mi edildi (`false`).
 * Çağıran (interceptor) yalnız `true` dönünce oturum-sonu bildirimini gösterir.
 */
export function onUnauthorized(): boolean {
  const now = Date.now()
  if (now - lastTriggeredAt < DEDUP_WINDOW_MS) return false
  lastTriggeredAt = now
  handler?.()
  return true
}

/** Test yardımcısı: modül durumunu sıfırla. */
export function __resetAuthBridge(): void {
  handler = null
  lastTriggeredAt = 0
}
